import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { VehicleDetailsLightBoxHeader } from './vehicle_details_light_box_header';
import { VehicleDetailsLightBoxContent } from './vehicle_details_light_box_content';

function VehicleDetailsLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['cross-sell-light-box__lightbox']}
            headerIcon="icon--wheel-alignment"

        >
            <div className="cross-sell-light-box">
                <VehicleDetailsLightBoxHeader />
                <VehicleDetailsLightBoxContent
                    expanded={props.expanded}
                    LightBoxVisible={props.LightBoxVisible}
                    onExpand={props.onExpand}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

VehicleDetailsLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    LightBoxVisible: PropTypes.bool.isRequired,
    onExpand: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { VehicleDetailsLightBox };
